import React from 'react'

export type PlayoffChoice = { type: 'additional_time' | 'penalties'; teamName: string }

interface PlayoffOutcomeModalProps {
  isOpen: boolean
  teamA: string
  teamB: string
  submitting?: boolean
  onSelect: (choice: PlayoffChoice) => void
  onClose: () => void
}

const PlayoffOutcomeModal: React.FC<PlayoffOutcomeModalProps> = ({
  isOpen,
  teamA,
  teamB,
  submitting = false,
  onSelect,
  onClose,
}) => {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60"
      onClick={() => {
        if (!submitting) onClose()
      }}
    >
      <div
        className="blue-sky-card rounded-2xl p-6 sm:p-8 max-w-md w-full shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-bold text-white mb-2">Playoff outcome</h3>
        <p className="text-white/80 text-sm mb-6">
          If the match goes beyond 90 minutes, who do you think will win?
        </p>
        {submitting ? (
          <div className="flex flex-col items-center gap-3 py-6">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white" />
            <p className="text-white/80 text-sm">Saving prediction…</p>
          </div>
        ) : (
          <div className="space-y-3">
            <p className="text-white/70 text-xs font-medium uppercase tracking-wide">Winner in extra time</p>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => onSelect({ type: 'additional_time', teamName: teamA })}
                className="flex-1 py-3 px-4 bg-primary hover:opacity-90 text-primary-foreground rounded-xl font-semibold text-sm"
              >
                {teamA}
              </button>
              <button
                type="button"
                onClick={() => onSelect({ type: 'additional_time', teamName: teamB })}
                className="flex-1 py-3 px-4 bg-primary hover:opacity-90 text-primary-foreground rounded-xl font-semibold text-sm"
              >
                {teamB}
              </button>
            </div>
            <p className="text-white/70 text-xs font-medium uppercase tracking-wide mt-4">Winner on penalties</p>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => onSelect({ type: 'penalties', teamName: teamA })}
                className="flex-1 py-3 px-4 bg-amber-500/90 hover:bg-amber-500 text-white rounded-xl font-semibold text-sm"
              >
                {teamA}
              </button>
              <button
                type="button"
                onClick={() => onSelect({ type: 'penalties', teamName: teamB })}
                className="flex-1 py-3 px-4 bg-amber-500/90 hover:bg-amber-500 text-white rounded-xl font-semibold text-sm"
              >
                {teamB}
              </button>
            </div>
          </div>
        )}
        <button
          type="button"
          onClick={onClose}
          disabled={submitting}
          className="mt-6 w-full py-2 text-white/70 hover:text-white text-sm disabled:opacity-40"
        >
          Cancel
        </button>
      </div>
    </div>
  )
}

export default PlayoffOutcomeModal
